// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Container,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { FaEye, FaEdit } from "react-icons/fa";
// import { RiDeleteBin5Fill } from "react-icons/ri";
// import { BsThreeDots } from "react-icons/bs";
// import {
//   MdAirplanemodeInactive,
//   MdAirplanemodeActive,
//   MdOutlineUpcoming,
//   MdUpcoming,
// } from "react-icons/md";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";
// import { FaDownload } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// const allowedDomains = [
//   "admin.rajasthanirealestates.in",
//   "realestateadmin.a2logicgroup.com",
// ];

// const dontallowedDomains = ["master.bahikhatas.com"];
// const currentDomain = window.location.host;

// function ActiveAssociateList() {
//   const [associates, setAssociates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedAssociate, setSelectedAssociate] = useState(null);
//   const [searchName, setSearchName] = useState("");
//   const [searchLocation, setSearchLocation] = useState("");
//   const searchTimeoutRef = useRef(null);
//   const [searchMobile, setSearchMobile] = useState("");
//   const [exporting, setExporting] = useState(false);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
  
//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     username: "",
//     email: "",
//     mobile: "",
//     whatsapp_number: "",
//     parent_id: "",
//   });

//   const limit = 10;
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const fetchAssociates = async (
//     page = 1, 
//     name = "", 
//     location = "",
//     from_date = "",
//     to_date = ""
//   ) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       let url = `${API_URL}/Associate-list-active?page=${page}&limit=10`;
//       if (name) url += `&mobile=${name}`;
//       if (location) url += `&parent_id=${location}`;
//       if (from_date) url += `&from_date=${from_date}`;
//       if (to_date) url += `&to_date=${to_date}`;

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error",
//           );
//           throw new Error("Unauthorized: Please log in again.");
//         }
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch associates.",
//           "error",
//         );
//         throw new Error(errorData.message || "Failed to fetch associates.");
//       }
//       const data = await response.json();
//       setAssociates(data.data || []);
//       setTotalPages(data.totalPages || 1);
//       setCurrentPage(page);
//     } catch (err) {
//       console.error("Fetch associates error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAssociates(currentPage);
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const exportAllToExcel = async () => {
//     setExporting(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert("Please login!");
//         return;
//       }

//       let url = `${API_URL}/Associate-excel-download`;
//       const params = new URLSearchParams();
//       if (fromDate) params.append('from_date', fromDate);
//       if (toDate) params.append('to_date', toDate);
//       if (params.toString()) {
//         url += `?${params.toString()}`;
//       }

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "text/csv",
//         },
//       });

//       if (!response.ok) {
//         alert("Server Error: Unable to download!");
//         return;
//       }

//       const csvData = await response.text();
//       const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       let fileName = `active_associates_${Date.now()}`;
//       if (fromDate) fileName += `_from_${fromDate}`;
//       if (toDate) fileName += `_to_${toDate}`;
//       fileName += `.csv`;
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", fileName);
//       link.click();
//     } catch (error) {
//       console.error("CSV Export Error:", error);
//       alert("Export Failed! Try again");
//     } finally {
//       setExporting(false);
//     }
//   };

//   const handleViewAssociate = async (associateId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       const response = await fetch(`${API_URL}/Associate-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: associateId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch associate details.",
//           "error",
//         );
//         throw new Error(
//           errorData.message || "Failed to fetch associate details.",
//         );
//       }

//       const data = await response.json();
//       setSelectedAssociate(data.data);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("View associate error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditAssociate = async (associateId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       // Fetch associate data
//       const response = await fetch(`${API_URL}/Associate-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: associateId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch associate for editing.",
//           "error",
//         );
//         throw new Error(
//           errorData.message || "Failed to fetch associate for editing.",
//         );
//       }

//       const data = await response.json();
//       const associateData = data.data;

//       setSelectedAssociate(associateData);

//       setEditFormData({
//         id: associateData.id || "",
//         username: associateData.username || "",
//         email: associateData.email || "",
//         mobile: associateData.mobile || "",
//         whatsapp_number: associateData.whatsapp_number || "",
//         parent_id: associateData.parent_id || "",
//       });

//       setShowEditModal(true);
//     } catch (err) {
//       console.error("Edit associate error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleUpdateAssociate = async (e) => {
//     e.preventDefault();

//     setLoading(true);
//     setError(null);

//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       const payload = { ...selectedAssociate };
//       payload.id = editFormData.id;
//       payload.username = editFormData.username;
//       payload.email = editFormData.email;
//       payload.mobile = editFormData.mobile;
//       payload.whatsapp_number = editFormData.whatsapp_number;
//       payload.parent_id = editFormData.parent_id;

//       const response = await fetch(`${API_URL}/Associate-update`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to update associate.",
//           "error",
//         );
//         throw new Error(errorData.message || "Failed to update associate.");
//       }

//       const result = await response.json();
//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           "Associate has been updated successfully!",
//           "success",
//         );
//         setShowEditModal(false);
//         fetchAssociates(currentPage);
//       } else {
//         showCustomMessageModal(
//           "Error",
//           result.message || "Something went wrong",
//           "error",
//         );
//       }
//     } catch (err) {
//       console.error("Update associate error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatusUpdate = async (associateId, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the status to ${newStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             throw new Error("Authentication token not found. Please log in.");
//           }

//           const response = await fetch(`${API_URL}/Associate-update-status`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({
//               id: associateId,
//               status: newStatus,
//             }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to update associate status.",
//               "error",
//             );
//             throw new Error(
//               errorData.message || "Failed to update associate status.",
//             );
//           }

//           const result = await response.json();
//           if ((result.success = "1")) {
//             showCustomMessageModal(
//               "Success",
//               "Associate status has been updated successfully!",
//               "success",
//             );
//             fetchAssociates(currentPage);
//           } else {
//             showCustomMessageModal(
//               "Error",
//               result.message || "Something went wrong",
//               "error",
//             );
//           }
//         } catch (err) {
//           console.error("Status update error:", err);
//         } finally {
//           setLoading(false);
//         }
//       },
//     );
//   };

//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setSelectedAssociate(null);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedAssociate(null);
//     setEditFormData({
//       id: "",
//       username: "",
//       email: "",
//       mobile: "",
//       whatsapp_number: "",
//     });
//   };

//   const handleSearchChange = (e) => {
//     setSearchName(e.target.value);
//   };

//   const handleSearchChangeLocation = (e) => {
//     setSearchLocation(e.target.value);
//   };

//   const handleFromDateChange = (e) => {
//     setFromDate(e.target.value);
//   };

//   const handleToDateChange = (e) => {
//     setToDate(e.target.value);
//   };

//   const handleSearchClick = () => {
//     setCurrentPage(1);
//     fetchAssociates(1, searchName.trim(), searchLocation.trim(), fromDate, toDate);
//   };

//   const handleClearSearch = () => {
//     setSearchName("");
//     setSearchLocation("");
//     setFromDate("");
//     setToDate("");
//     setCurrentPage(1);
//     fetchAssociates(1, "", "", "", "");
//   };

//   const handleDeleteAssociate = async (associateId, associateName) => {
//     showCustomMessageModal(
//       "Confirm Delete",
//       `Are you sure you want to delete associate "${associateName}"? This action cannot be undone.`,
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             throw new Error("Authentication token not found. Please log in.");
//           }

//           const response = await fetch(`${API_URL}/delete-associate`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: associateId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to delete associate.",
//               "error",
//             );
//             throw new Error(errorData.message || "Failed to delete associate.");
//           }

//           const result = await response.json();
//           if (result.status == "1") {
//             showCustomMessageModal(
//               "Success",
//               "Associate has been deleted successfully!",
//               "success",
//             );
//             fetchAssociates();
//           } else {
//             showCustomMessageModal(
//               "Error",
//               result.message || "Something went wrong",
//               "error",
//             );
//           }
//         } catch (err) {
//           console.error("Delete associate error:", err);
//         } finally {
//           setLoading(false);
//         }
//       },
//     );
//   };

//   if (loading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ minHeight: "80vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   // return (
//   //   <>
//   //     <div className="card mt-2">
//   //       <div className="card-header">
//   //         <div className="d-flex flex-wrap-mobile gap-2 align-items-center justify-content-between">
//   //           <div className="titlepage">
//   //             <h3>Active Associate List</h3>
//   //           </div>

//   //           <div className="d-flex gap-2">
//   //             <>
//   //               {!dontallowedDomains.includes(currentDomain) && (
//   //                 <div className="createnewadmin">
//   //                   <button
//   //                     className="exportexcel btn gap-2 btn-success d-inline-flex align-items-center"
//   //                     onClick={exportAllToExcel}
//   //                     disabled={exporting}
//   //                   >
//   //                     <FaDownload />
//   //                     {exporting ? (
//   //                       <>
//   //                         <span
//   //                           className="spinner-border spinner-border-sm me-2"
//   //                           role="status"
//   //                           aria-hidden="true"
//   //                         ></span>
//   //                         Exporting...
//   //                       </>
//   //                     ) : (
//   //                       "Export"
//   //                     )}
//   //                   </button>
//   //                 </div>
//   //               )}
//   //             </>
//   //             <div className="createnewadmin">
//   //               <Link
//   //                 to="/create-associate"
//   //                 className="btn btn-success d-inline-flex align-items-center"
//   //               >
//   //                 <FaPlus className="me-2" /> Associate
//   //               </Link>
//   //             </div>
//   //             <button
//   //               className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//   //               onClick={handleToggle}
//   //             >
//   //               {isFilterActive ? (
//   //                 <>
//   //                   <MdFilterAltOff />
//   //                 </>
//   //               ) : (
//   //                 <>
//   //                   <MdFilterAlt />
//   //                 </>
//   //               )}
//   //             </button>
//   //           </div>
//   //         </div>
//   //       </div>

//   //       <div className="card-body">
//   //         {isFilterActive && (
//   //           <div className="d-flex gap-2 mb-3 mt-2 flex-wrap-mobile">
//   //             <div className="form-group w-100" id="searchName">
//   //               <input
//   //                 type="text"
//   //                 placeholder="Search Mobile"
//   //                 value={searchName}
//   //                 onChange={handleSearchChange}
//   //                 className="form-control"
//   //               />
//   //             </div>

//   //             <div className="form-group w-100" id="searchLocation">
//   //               <input
//   //                 type="text"
//   //                 placeholder="Parent ID"
//   //                 value={searchLocation}
//   //                 onChange={handleSearchChangeLocation}
//   //                 className="form-control"
//   //               />
//   //             </div>

//   //             <div className="form-group w-100" id="fromDate">
//   //               <input
//   //                 type="date"
//   //                 placeholder="From Date"
//   //                 value={fromDate}
//   //                 onChange={handleFromDateChange}
//   //                 className="form-control"
//   //               />
//   //             </div>

//   //             <div className="form-group w-100" id="toDate">
//   //               <input
//   //                 type="date"
//   //                 placeholder="To Date"
//   //                 value={toDate}
//   //                 onChange={handleToDateChange}
//   //                 className="form-control"
//   //               />
//   //             </div>

//   //             <div className="d-flex gap-2">
//   //               <button className="btn btn-primary" onClick={handleSearchClick}>
//   //                 Search
//   //               </button>
//   //               <button className="btn btn-secondary" onClick={handleClearSearch}>
//   //                 Clear
//   //               </button>
//   //             </div>
//   //           </div>
//   //         )}

//   //         <div className="table-responsive">
//   //           <Table bordered>
//   //             <thead className="bg-primary text-white">
//   //               <tr>
//   //                 <th>ID</th>
//   //                 <th>Name</th>
//   //                 <th>Mobile</th>
//   //                 <th>Password</th>
//   //                 <th>KYC Status</th>
//   //                 <th>Parent Name</th>
//   //                 <th>Parent ID</th>
//   //                 <th>Status</th>
//   //                 <th>Date Of Joining</th>
//   //                 <th>Action</th>
//   //               </tr>
//   //             </thead>
//   //             <tbody>
//   //               {associates.length > 0 ? (
//   //                 associates.map((associate, i) => (
//   //                   <tr key={associate.id}>
//   //                     <td>{(currentPage - 1) * limit + i + 1}</td>
//   //                     <td>
//   //                       {associate.username
//   //                         ? associate.username.charAt(0).toUpperCase() +
//   //                           associate.username.slice(1).toLowerCase()
//   //                         : "-"}
//   //                     </td>

//   //                     <td>{associate.mobile}</td>
//   //                     <td>{associate.password}</td>
//   //                     <td
//   //                       style={{
//   //                         color:
//   //                           associate.kyc?.toLowerCase() === "success"
//   //                             ? "green"
//   //                             : associate.kyc?.toLowerCase() === "pending"
//   //                               ? "orange"
//   //                               : "red",
//   //                         fontWeight: "500",
//   //                       }}
//   //                     >
//   //                       {associate.kyc
//   //                         ? associate.kyc.charAt(0).toUpperCase() +
//   //                           associate.kyc.slice(1).toLowerCase()
//   //                         : "-"}
//   //                     </td>

//   //                     <td>
//   //                       {associate.parent_name
//   //                         ? associate.parent_name.charAt(0).toUpperCase() +
//   //                           associate.parent_name.slice(1).toLowerCase()
//   //                         : "-"}
//   //                     </td>

//   //                     <td>{associate.parent_id}</td>
//   //                     <td>
//   //                       <span
//   //                         className={`badge ${
//   //                           associate.status === "active"
//   //                             ? "bg-success"
//   //                             : "bg-danger"
//   //                         }`}
//   //                       >
//   //                         {associate.status}
//   //                       </span>
//   //                     </td>
//   //                     <td>
//   //                       {associate.date
//   //                         ? (() => {
//   //                             const [day, month, year] =
//   //                               associate.date.split("-");
//   //                             return `${day}-${month}-${year}`;
//   //                           })()
//   //                         : "-"}
//   //                     </td>

//   //                     <td>
//   //                       <div className="dropdown">
//   //                         <button
//   //                           className="btn light btn-action dropdown-toggle"
//   //                           type="button"
//   //                           id="dropdownMenuButton"
//   //                           data-bs-toggle="dropdown"
//   //                           aria-expanded="false"
//   //                         >
//   //                           <BsThreeDots size={20} />
//   //                         </button>
//   //                         <ul
//   //                           className="dropdown-menu"
//   //                           aria-labelledby="dropdownMenuButton"
//   //                         >
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn view_btn btn-sm"
//   //                               onClick={() => handleViewAssociate(associate.id)}
//   //                               title="View Project Details"
//   //                             >
//   //                               <FaEye /> View
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn view_btn btn-sm"
//   //                               title="View Project Details"
//   //                               onClick={() => handleEditAssociate(associate.id)}
//   //                             >
//   //                               <FaEdit /> Edit
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               variant={
//   //                                 associate.status === "active"
//   //                                   ? "danger"
//   //                                   : "success"
//   //                               }
//   //                               className="btn btn-sm btn-danger"
//   //                               onClick={() =>
//   //                                 handleStatusUpdate(
//   //                                   associate.id,
//   //                                   associate.status,
//   //                                 )
//   //                               }
//   //                             >
//   //                               {associate.status === "active" ? (
//   //                                 <MdAirplanemodeInactive />
//   //                               ) : (
//   //                                 <MdAirplanemodeActive />
//   //                               )}

//   //                               {associate.status === "active"
//   //                                 ? "Deactivate"
//   //                                 : "Activate"}
//   //                             </button>
//   //                           </li>

//   //                           {/* Add Delete Option Here */}
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn btn-sm text-danger"
//   //                               onClick={() =>
//   //                                 handleDeleteAssociate(
//   //                                   associate.id,
//   //                                   associate.username,
//   //                                 )
//   //                               }
//   //                               title="Delete Associate"
//   //                               style={{
//   //                                 width: "100%",
//   //                                 textAlign: "left",
//   //                                 backgroundColor: "transparent",
//   //                               }}
//   //                             >
//   //                               <RiDeleteBin5Fill className="text-danger" />{" "}
//   //                               <span className="text-danger">Delete</span>
//   //                             </button>
//   //                           </li>

//   //                           <li className="dropdown-item">
//   //                             <a
//   //                               href={`${process.env.REACT_APP_API_ASSCIATELOGIN_URL}/login?mobile=${associate.mobile}&pssword=${associate.password}`}
//   //                               target="_blank"
//   //                               rel="noopener noreferrer"
//   //                               className="btn view_btn btn-sm"
//   //                               title="View Project Details"
//   //                             >
//   //                               <FaEdit /> Login
//   //                             </a>
//   //                           </li>

//   //                           <li className="dropdown-item">
//   //                             <Link
//   //                               to={`/team-list/${associate.mobile}?name=${encodeURIComponent(associate.username)}`}
//   //                               className="btn view_btn btn-sm"
//   //                               title="View Project Details"
//   //                             >
//   //                               <FaEye /> View Teams
//   //                             </Link>
//   //                           </li>
//   //                         </ul>
//   //                       </div>
//   //                     </td>
//   //                   </tr>
//   //                 ))
//   //               ) : (
//   //                 <tr>
//   //                   <td colSpan="10" className="text-center">
//   //                     No associates found.
//   //                   </td>
//   //                 </tr>
//   //               )}
//   //             </tbody>
//   //           </Table>
//   //         </div>

//   //         <div className="d-flex justify-content-end">
//   //           <Pagination>
//   //             <Pagination.Prev
//   //               onClick={() => handlePageChange(currentPage - 1)}
//   //               disabled={currentPage === 1}
//   //             />

//   //             <Pagination.Item
//   //               active={1 === currentPage}
//   //               onClick={() => handlePageChange(1)}
//   //             >
//   //               1
//   //             </Pagination.Item>

//   //             {currentPage > 3 && <Pagination.Ellipsis />}

//   //             {currentPage > 2 && (
//   //               <Pagination.Item
//   //                 onClick={() => handlePageChange(currentPage - 1)}
//   //               >
//   //                 {currentPage - 1}
//   //               </Pagination.Item>
//   //             )}

//   //             {currentPage !== 1 && currentPage !== totalPages && (
//   //               <Pagination.Item active>{currentPage}</Pagination.Item>
//   //             )}

//   //             {currentPage < totalPages - 1 && (
//   //               <Pagination.Item
//   //                 onClick={() => handlePageChange(currentPage + 1)}
//   //               >
//   //                 {currentPage + 1}
//   //               </Pagination.Item>
//   //             )}

//   //             {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

//   //             {totalPages > 1 && (
//   //               <Pagination.Item
//   //                 active={totalPages === currentPage}
//   //                 onClick={() => handlePageChange(totalPages)}
//   //               >
//   //                 {totalPages}
//   //               </Pagination.Item>
//   //             )}

//   //             <Pagination.Next
//   //               onClick={() => handlePageChange(currentPage + 1)}
//   //               disabled={currentPage === totalPages}
//   //             />
//   //           </Pagination>
//   //         </div>
//   //       </div>
//   //     </div>

//   //     {/* View Associate Modal */}
//   //     <Modal
//   //       show={showViewModal}
//   //       onHide={handleCloseViewModal}
//   //       centered
//   //       size="lg"
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Associate Details</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         {selectedAssociate && (
//   //           <Row>
//   //             <div className="col-md-12">
//   //               <table className="table">
//   //                 <tbody>
//   //                   <tr>
//   //                     <th>Name</th>
//   //                     <td>{selectedAssociate.username}</td>
//   //                   </tr>
//   //                   <tr>
//   //                     <th>Email</th>
//   //                     <td>{selectedAssociate.email}</td>
//   //                   </tr>
//   //                   <tr>
//   //                     <th>Mobile</th>
//   //                     <td>{selectedAssociate.mobile}</td>
//   //                   </tr>
//   //                   <tr>
//   //                     <th>WhatsApp No.</th>
//   //                     <td>{selectedAssociate.whatsapp_number}</td>
//   //                   </tr>
//   //                 </tbody>
//   //               </table>
//   //             </div>
//   //           </Row>
//   //         )}
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="secondary" onClick={handleCloseViewModal}>
//   //           Close
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     <Modal
//   //       show={showEditModal}
//   //       onHide={handleCloseEditModal}
//   //       centered
//   //       size="lg"
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Edit Associate</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         <Form onSubmit={handleUpdateAssociate}>
//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3" controlId="editUsername">
//   //                 <Form.Label>Name</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="username"
//   //                   value={editFormData.username}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3" controlId="editEmail">
//   //                 <Form.Label>Email</Form.Label>
//   //                 <Form.Control
//   //                   type="email"
//   //                   name="email"
//   //                   value={editFormData.email}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>
//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3" controlId="editMobile">
//   //                 <Form.Label>Mobile</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="mobile"
//   //                   value={editFormData.mobile}
//   //                   onChange={handleEditFormChange}
//   //                   maxLength="10"
//   //                   required
//   //                   readOnly
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3" controlId="editWhatsappNumber">
//   //                 <Form.Label>WhatsApp Number</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="whatsapp_number"
//   //                   value={editFormData.whatsapp_number}
//   //                   maxLength="10"
//   //                   onChange={handleEditFormChange}
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>
//   //           <Button
//   //             variant="primary"
//   //             type="submit"
//   //             className="w-100"
//   //             disabled={loading}
//   //           >
//   //             {loading ? "Updating..." : "Update Associate"}
//   //           </Button>
//   //         </Form>
//   //       </Modal.Body>
//   //     </Modal>

//   //     {showMessageModal && (
//   //       <div
//   //         className="modal d-block modalshowparentdesign"
//   //         tabIndex="-1"
//   //         style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//   //       >
//   //         <div className="modal-dialog modal-dialog-centered">
//   //           <div
//   //             className={`modal-content ${messageModalContent.type === "success" ? "" : messageModalContent.type === "error" ? "" : ""}`}
//   //           >
//   //             <div className="modal-header d-flex justify-content-between align-items-center">
//   //               <h5
//   //                 className={`modal-title ${messageModalContent.type === "success" ? "" : messageModalContent.type === "error" ? "" : ""}`}
//   //               >
//   //                 {messageModalContent.title}
//   //               </h5>
//   //               <button
//   //                 type="button"
//   //                 className="btn-close"
//   //                 aria-label="Close"
//   //                 onClick={closeCustomMessageModal}
//   //               ></button>
//   //             </div>
//   //             <div className="modal-body text-secondary">
//   //               <p>{messageModalContent.text}</p>
//   //             </div>
//   //             <div className="modal-footer justify-content-center">
//   //               {messageModalContent.confirmAction ? (
//   //                 <>
//   //                   <Button
//   //                     variant={
//   //                       messageModalContent.type === "btn-primary-custum"
//   //                         ? "btn-primary-custum"
//   //                         : "primary"
//   //                     }
//   //                     onClick={() => {
//   //                       messageModalContent.confirmAction();
//   //                       closeCustomMessageModal();
//   //                     }}
//   //                   >
//   //                     Confirm
//   //                   </Button>
//   //                   <Button variant="danger" onClick={closeCustomMessageModal}>
//   //                     Cancel
//   //                   </Button>
//   //                 </>
//   //               ) : (
//   //                 <Button
//   //                   variant={
//   //                     messageModalContent.type === "success"
//   //                       ? "success"
//   //                       : messageModalContent.type === "error"
//   //                         ? "danger"
//   //                         : "primary"
//   //                   }
//   //                   onClick={closeCustomMessageModal}
//   //                 >
//   //                   OK
//   //                 </Button>
//   //               )}
//   //             </div>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     )}
//   //   </>
//   // );
// return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               👥
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Active Associate List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage all active associates here
//               </p>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 flexWrap: "wrap",
//                 alignItems: "center",
//               }}
//             >
//               {!dontallowedDomains.includes(currentDomain) && (
//                 <button
//                   onClick={exportAllToExcel}
//                   disabled={exporting}
//                   style={{
//                     padding: "12px 20px",
//                     borderRadius: "12px",
//                     border: "none",
//                     background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                     color: "#ffffff",
//                     fontSize: "14px",
//                     fontWeight: "700",
//                     cursor: exporting ? "not-allowed" : "pointer",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                   }}
//                 >
//                   <FaDownload />
//                   {exporting ? "Exporting..." : "Export"}
//                 </button>
//               )}

//               <Link
//                 to="/create-associate"
//                 style={{
//                   padding: "12px 20px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "14px",
//                   fontWeight: "700",
//                   textDecoration: "none",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 <FaPlus /> Associate
//               </Link>

//               <button
//                 onClick={handleToggle}
//                 style={{
//                   padding: "12px 16px",
//                   borderRadius: "12px",
//                   border: "1.5px solid #e2e8f0",
//                   background: isFilterActive ? "#1e5799" : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                   fontSize: "16px",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//                 title="Toggle Filters"
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "24px" }}>
//               {/* 🎯 FILTERS */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "10px",
//                     marginBottom: "20px",
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   <input
//                     type="text"
//                     placeholder="Search Mobile"
//                     value={searchName}
//                     onChange={handleSearchChange}
//                     style={{
//                       flex: 1,
//                       minWidth: "160px",
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                       outline: "none",
//                     }}
//                   />
//                   <input
//                     type="text"
//                     placeholder="Parent ID"
//                     value={searchLocation}
//                     onChange={handleSearchChangeLocation}
//                     style={{
//                       flex: 1,
//                       minWidth: "160px",
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                       outline: "none",
//                     }}
//                   />
//                   <input
//                     type="date"
//                     value={fromDate}
//                     onChange={handleFromDateChange}
//                     style={{
//                       flex: 1,
//                       minWidth: "160px",
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                       outline: "none",
//                     }}
//                   />
//                   <input
//                     type="date"
//                     value={toDate}
//                     onChange={handleToDateChange}
//                     style={{
//                       flex: 1,
//                       minWidth: "160px",
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                       outline: "none",
//                     }}
//                   />

//                   <button
//                     onClick={handleSearchClick}
//                     style={{
//                       padding: "10px 20px",
//                       borderRadius: "10px",
//                       border: "none",
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                       fontWeight: "700",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Search
//                   </button>
//                   <button
//                     onClick={handleClearSearch}
//                     style={{
//                       padding: "10px 20px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                       background: "#f8fafc",
//                       color: "#1e3a5f",
//                       fontWeight: "700",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Clear
//                   </button>
//                 </div>
//               )}

//               <div className="table-responsive">
//                 <Table bordered hover>
//                   <thead
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                     }}
//                   >
//                     <tr>
//                       <th>ID</th>
//                       <th>Name</th>
//                       <th>Mobile</th>
//                       <th>Password</th>
//                       <th>KYC Status</th>
//                       <th>Parent Name</th>
//                       <th>Parent ID</th>
//                       <th>Status</th>
//                       <th>Date Of Joining</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {associates.length > 0 ? (
//                       associates.map((associate, i) => (
//                         <tr key={associate.id}>
//                           <td>{(currentPage - 1) * limit + i + 1}</td>
//                           <td>
//                             {associate.username
//                               ? associate.username.charAt(0).toUpperCase() +
//                                 associate.username.slice(1).toLowerCase()
//                               : "-"}
//                           </td>
//                           <td>{associate.mobile}</td>
//                           <td>{associate.password}</td>
//                           <td
//                             style={{
//                               color:
//                                 associate.kyc?.toLowerCase() === "success"
//                                   ? "green"
//                                   : associate.kyc?.toLowerCase() === "pending"
//                                     ? "orange"
//                                     : "red",
//                               fontWeight: "500",
//                             }}
//                           >
//                             {associate.kyc
//                               ? associate.kyc.charAt(0).toUpperCase() +
//                                 associate.kyc.slice(1).toLowerCase()
//                               : "-"}
//                           </td>
//                           <td>
//                             {associate.parent_name
//                               ? associate.parent_name
//                                   .charAt(0)
//                                   .toUpperCase() +
//                                 associate.parent_name.slice(1).toLowerCase()
//                               : "-"}
//                           </td>
//                           <td>{associate.parent_id}</td>
//                           <td>
//                             <span
//                               className={`badge ${
//                                 associate.status === "active"
//                                   ? "bg-success"
//                                   : "bg-danger"
//                               }`}
//                             >
//                               {associate.status}
//                             </span>
//                           </td>
//                           <td>
//                             {associate.date
//                               ? (() => {
//                                   const [day, month, year] =
//                                     associate.date.split("-");
//                                   return `${day}-${month}-${year}`;
//                                 })()
//                               : "-"}
//                           </td>
//                           <td>
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 id={`dropdownMenuButton-${associate.id}`}
//                                 data-bs-toggle="dropdown"
//                                 aria-expanded="false"
//                               >
//                                 <BsThreeDots size={20} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 aria-labelledby={`dropdownMenuButton-${associate.id}`}
//                               >
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm"
//                                     onClick={() =>
//                                       handleViewAssociate(associate.id)
//                                     }
//                                   >
//                                     <FaEye /> View
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm"
//                                     onClick={() =>
//                                       handleEditAssociate(associate.id)
//                                     }
//                                   >
//                                     <FaEdit /> Edit
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn btn-sm btn-danger"
//                                     onClick={() =>
//                                       handleStatusUpdate(
//                                         associate.id,
//                                         associate.status,
//                                       )
//                                     }
//                                   >
//                                     {associate.status === "active" ? (
//                                       <MdAirplanemodeInactive />
//                                     ) : (
//                                       <MdAirplanemodeActive />
//                                     )}
//                                     {associate.status === "active"
//                                       ? "Deactivate"
//                                       : "Activate"}
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn btn-sm text-danger"
//                                     onClick={() =>
//                                       handleDeleteAssociate(
//                                         associate.id,
//                                         associate.username,
//                                       )
//                                     }
//                                     style={{
//                                       width: "100%",
//                                       textAlign: "left",
//                                       backgroundColor: "transparent",
//                                     }}
//                                   >
//                                     <RiDeleteBin5Fill className="text-danger" />{" "}
//                                     <span className="text-danger">Delete</span>
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <a
//                                     href={`${process.env.REACT_APP_API_ASSCIATELOGIN_URL}/login?mobile=${associate.mobile}&pssword=${associate.password}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="btn view_btn btn-sm"
//                                   >
//                                     <FaEdit /> Login
//                                   </a>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <Link
//                                     to={`/team-list/${associate.mobile}?name=${encodeURIComponent(associate.username)}`}
//                                     className="btn view_btn btn-sm"
//                                   >
//                                     <FaEye /> View Teams
//                                   </Link>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="10" className="text-center py-4">
//                           No associates found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>

//               {/* 🎯 PAGINATION */}
//               <div className="d-flex justify-content-end mt-3">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   <Pagination.Item
//                     active={1 === currentPage}
//                     onClick={() => handlePageChange(1)}
//                   >
//                     1
//                   </Pagination.Item>
//                   {currentPage > 3 && <Pagination.Ellipsis />}
//                   {currentPage > 2 && (
//                     <Pagination.Item
//                       onClick={() => handlePageChange(currentPage - 1)}
//                     >
//                       {currentPage - 1}
//                     </Pagination.Item>
//                   )}
//                   {currentPage !== 1 && currentPage !== totalPages && (
//                     <Pagination.Item active>{currentPage}</Pagination.Item>
//                   )}
//                   {currentPage < totalPages - 1 && (
//                     <Pagination.Item
//                       onClick={() => handlePageChange(currentPage + 1)}
//                     >
//                       {currentPage + 1}
//                     </Pagination.Item>
//                   )}
//                   {currentPage < totalPages - 2 && <Pagination.Ellipsis />}
//                   {totalPages > 1 && (
//                     <Pagination.Item
//                       active={totalPages === currentPage}
//                       onClick={() => handlePageChange(totalPages)}
//                     >
//                       {totalPages}
//                     </Pagination.Item>
//                   )}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 VIEW MODAL */}
//       <Modal
//         show={showViewModal}
//         onHide={handleCloseViewModal}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Associate Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedAssociate && (
//             <Row>
//               <div className="col-md-12">
//                 <table className="table">
//                   <tbody>
//                     <tr>
//                       <th>Name</th>
//                       <td>{selectedAssociate.username}</td>
//                     </tr>
//                     <tr>
//                       <th>Email</th>
//                       <td>{selectedAssociate.email}</td>
//                     </tr>
//                     <tr>
//                       <th>Mobile</th>
//                       <td>{selectedAssociate.mobile}</td>
//                     </tr>
//                     <tr>
//                       <th>WhatsApp No.</th>
//                       <td>{selectedAssociate.whatsapp_number}</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </Row>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseViewModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 EDIT MODAL */}
//       <Modal
//         show={showEditModal}
//         onHide={handleCloseEditModal}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Edit Associate
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdateAssociate}>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editUsername">
//                   <Form.Label>Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="username"
//                     value={editFormData.username}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editEmail">
//                   <Form.Label>Email</Form.Label>
//                   <Form.Control
//                     type="email"
//                     name="email"
//                     value={editFormData.email}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editMobile">
//                   <Form.Label>Mobile</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="mobile"
//                     value={editFormData.mobile}
//                     onChange={handleEditFormChange}
//                     maxLength="10"
//                     required
//                     readOnly
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3" controlId="editWhatsappNumber">
//                   <Form.Label>WhatsApp Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="whatsapp_number"
//                     value={editFormData.whatsapp_number}
//                     maxLength="10"
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Button
//               variant="primary"
//               type="submit"
//               className="w-100"
//               disabled={loading}
//             >
//               {loading ? "Updating..." : "Update Associate"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* 🎯 MESSAGE MODAL */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content ${
//                 messageModalContent.type === "success" ? "border-success" : ""
//               }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${
//                     messageModalContent.type === "success"
//                       ? "text-success"
//                       : messageModalContent.type === "error"
//                         ? "text-danger"
//                         : "text-warning"
//                   }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                           ? "danger"
//                           : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ActiveAssociateList;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaPlus, FaEye, FaEdit, FaDownload } from "react-icons/fa";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import {
  MdAirplanemodeInactive,
  MdAirplanemodeActive,
} from "react-icons/md";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 10;

const dontallowedDomains = ["master.bahikhatas.com"];
const currentDomain = window.location.host;

function ActiveAssociateList() {
  const [associates, setAssociates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // ✅ NEW
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAssociate, setSelectedAssociate] = useState(null);
  const [searchName, setSearchName] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [searchMobile, setSearchMobile] = useState("");
  const [exporting, setExporting] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [editFormData, setEditFormData] = useState({
    id: "",
    username: "",
    email: "",
    mobile: "",
    whatsapp_number: "",
    parent_id: "",
  });

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });
  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const getAuthToken = () => localStorage.getItem("token");

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH ASSOCIATES (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchAssociates = async (
    page = 1,
    name = "",
    location = "",
    from_date = "",
    to_date = ""
  ) => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      let url = `${API_URL}/Associate-list-active?page=${page}&limit=${LIMIT}`;
      if (name) url += `&mobile=${name}`;
      if (location) url += `&parent_id=${location}`;
      if (from_date) url += `&from_date=${from_date}`;
      if (to_date) url += `&to_date=${to_date}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          showCustomMessageModal(
            "Authorization Error",
            "Unauthorized: Please log in again.",
            "error"
          );
        }
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch associates.");
      }

      const data = await response.json();
      setAssociates(data.data || []);

      // ✅ Server se totalPages aur total dono set karo
      const pages = Number(data.totalPages) || 1;
      const total = Number(data.total) || (data.data?.length || 0);

      setTotalPages(pages);
      setTotalItems(total);
      setCurrentPage(Number(data.currentPage) || Number(page));
    } catch (err) {
      console.error("Fetch associates error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssociates(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // ═══════════════════════════════════════════
  // 🔹 EXPORT CSV
  // ═══════════════════════════════════════════
  const exportAllToExcel = async () => {
    setExporting(true);
    try {
      const token = getAuthToken();
      if (!token) {
        alert("Please login!");
        return;
      }

      let url = `${API_URL}/Associate-excel-download`;
      const params = new URLSearchParams();
      if (fromDate) params.append("from_date", fromDate);
      if (toDate) params.append("to_date", toDate);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/csv",
        },
      });

      if (!response.ok) {
        alert("Server Error: Unable to download!");
        return;
      }

      const csvData = await response.text();
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      let fileName = `active_associates_${Date.now()}`;
      if (fromDate) fileName += `_from_${fromDate}`;
      if (toDate) fileName += `_to_${toDate}`;
      fileName += `.csv`;
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", fileName);
      link.click();
    } catch (error) {
      console.error("CSV Export Error:", error);
      alert("Export Failed! Try again");
    } finally {
      setExporting(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 VIEW ASSOCIATE
  // ═══════════════════════════════════════════
  const handleViewAssociate = async (associateId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/Associate-view`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: associateId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch associate details."
        );
      }

      const data = await response.json();
      setSelectedAssociate(data.data);
      setShowViewModal(true);
    } catch (err) {
      console.error("View associate error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT ASSOCIATE
  // ═══════════════════════════════════════════
  const handleEditAssociate = async (associateId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/Associate-view`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: associateId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch associate for editing."
        );
      }

      const data = await response.json();
      const associateData = data.data;

      setSelectedAssociate(associateData);

      setEditFormData({
        id: associateData.id || "",
        username: associateData.username || "",
        email: associateData.email || "",
        mobile: associateData.mobile || "",
        whatsapp_number: associateData.whatsapp_number || "",
        parent_id: associateData.parent_id || "",
      });

      setShowEditModal(true);
    } catch (err) {
      console.error("Edit associate error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ═══════════════════════════════════════════
  // 🔹 UPDATE ASSOCIATE
  // ═══════════════════════════════════════════
  const handleUpdateAssociate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        return;
      }

      const payload = { ...selectedAssociate };
      payload.id = editFormData.id;
      payload.username = editFormData.username;
      payload.email = editFormData.email;
      payload.mobile = editFormData.mobile;
      payload.whatsapp_number = editFormData.whatsapp_number;
      payload.parent_id = editFormData.parent_id;

      const response = await fetch(`${API_URL}/Associate-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update associate.");
      }

      const result = await response.json();
      if (result.success == "1") {
        showCustomMessageModal(
          "Success",
          "Associate has been updated successfully!",
          "success"
        );
        setShowEditModal(false);
        fetchAssociates(currentPage);
      } else {
        showCustomMessageModal(
          "Error",
          result.message || "Something went wrong",
          "error"
        );
      }
    } catch (err) {
      console.error("Update associate error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = (associateId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    showCustomMessageModal(
      "Confirm Status Change",
      `Do you want to change the status to ${newStatus}?`,
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/Associate-update-status`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: associateId, status: newStatus }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
              errorData.message || "Failed to update associate status."
            );
          }

          const result = await response.json();
          if (result.success == "1") {
            showCustomMessageModal(
              "Success",
              "Associate status has been updated successfully!",
              "success"
            );
            fetchAssociates(currentPage);
          } else {
            showCustomMessageModal(
              "Error",
              result.message || "Something went wrong",
              "error"
            );
          }
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE ASSOCIATE
  // ═══════════════════════════════════════════
  const handleDeleteAssociate = (associateId, associateName) => {
    showCustomMessageModal(
      "Confirm Delete",
      `Are you sure you want to delete associate "${associateName}"? This action cannot be undone.`,
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/delete-associate`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: associateId }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
              errorData.message || "Failed to delete associate."
            );
          }

          const result = await response.json();
          if (result.status == "1") {
            showCustomMessageModal(
              "Success",
              "Associate has been deleted successfully!",
              "success"
            );
            fetchAssociates();
          } else {
            showCustomMessageModal(
              "Error",
              result.message || "Something went wrong",
              "error"
            );
          }
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedAssociate(null);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedAssociate(null);
    setEditFormData({
      id: "",
      username: "",
      email: "",
      mobile: "",
      whatsapp_number: "",
      parent_id: "",
    });
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    fetchAssociates(
      1,
      searchName.trim(),
      searchLocation.trim(),
      fromDate,
      toDate
    );
  };

  const handleClearSearch = () => {
    setSearchName("");
    setSearchLocation("");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    fetchAssociates(1, "", "", "", "");
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 PAGINATION PAGES GENERATOR
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);

    if (showEllipsis && currentPage > 4) {
      pages.push("left-ellipsis");
    }

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (showEllipsis && currentPage < totalPages - 3) {
      pages.push("right-ellipsis");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                ✅
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Active Associate List
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all active associates ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {!dontallowedDomains.includes(currentDomain) && (
                <button
                  onClick={exportAllToExcel}
                  disabled={exporting}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "10px",
                    border: "none",
                    background: "linear-gradient(135deg, #059669, #047857)",
                    color: "#ffffff",
                    fontSize: "13px",
                    fontWeight: "700",
                    cursor: exporting ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                  }}
                >
                  <FaDownload /> {exporting ? "Exporting..." : "Export"}
                </button>
              )}

              <Link
                to="/create-associate"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Associate
              </Link>

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>Mobile</label>
                  <input
                    type="text"
                    placeholder="Search Mobile"
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>Parent ID</label>
                  <input
                    type="text"
                    placeholder="Parent ID"
                    value={searchLocation}
                    onChange={(e) => setSearchLocation(e.target.value)}
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>From Date</label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>To Date</label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    style={inputStyle}
                  />
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={handleSearchClick}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "10px",
                      border: "none",
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    onClick={handleClearSearch}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      color: "#64748b",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Name",
                      "Mobile",
                      "Password",
                      "KYC",
                      "Parent Name",
                      "Parent ID",
                      "Status",
                      "Joining Date",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {associates.length > 0 ? (
                    associates.map((associate, i) => (
                      <tr
                        key={associate.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + i + 1}
                        </td>
                        <td style={cellDark}>
                          {associate.username
                            ? associate.username.charAt(0).toUpperCase() +
                              associate.username.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{associate.mobile}</td>
                        <td style={cellGray}>{associate.password}</td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11px",
                              fontWeight: "700",
                              textTransform: "capitalize",
                              background:
                                associate.kyc?.toLowerCase() === "success"
                                  ? "#e7f9eb"
                                  : associate.kyc?.toLowerCase() === "pending"
                                  ? "#fef3e2"
                                  : "#feeaeb",
                              color:
                                associate.kyc?.toLowerCase() === "success"
                                  ? "#059669"
                                  : associate.kyc?.toLowerCase() === "pending"
                                  ? "#d97706"
                                  : "#dc2626",
                            }}
                          >
                            {associate.kyc || "-"}
                          </span>
                        </td>
                        <td style={cellDark}>
                          {associate.parent_name
                            ? associate.parent_name
                                .charAt(0)
                                .toUpperCase() +
                              associate.parent_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{associate.parent_id}</td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background:
                                associate.status === "active"
                                  ? "#e7f9eb"
                                  : "#feeaeb",
                              color:
                                associate.status === "active"
                                  ? "#059669"
                                  : "#dc2626",
                              textTransform: "capitalize",
                            }}
                          >
                            {associate.status}
                          </span>
                        </td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {associate.date || "-"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-boundary="viewport"
                              data-bs-popper-config='{"strategy":"fixed"}'
                              aria-expanded="false"
                              style={{
                                background: "#f8fafc",
                                border: "1.5px solid #e2e8f0",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1e5799",
                                padding: 0,
                              }}
                            >
                              <BsThreeDots size={18} />
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{
                                zIndex: 9999,
                                borderRadius: "14px",
                                border: "none",
                                padding: "8px",
                                boxShadow:
                                  "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                minWidth: "230px",
                                marginTop: "8px",
                                background: "#ffffff",
                              }}
                            >
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleViewAssociate(associate.id)
                                  }
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e8f1fb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Details
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleEditAssociate(associate.id)
                                  }
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e7f9eb", "#059669")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Edit Associate
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleStatusUpdate(
                                      associate.id,
                                      associate.status
                                    )
                                  }
                                  style={{
                                    ...dropdownItem,
                                    color:
                                      associate.status === "active"
                                        ? "#dc2626"
                                        : "#059669",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      associate.status === "active"
                                        ? "#feeaeb"
                                        : "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span
                                    style={iconBadge(
                                      associate.status === "active"
                                        ? "#feeaeb"
                                        : "#e7f9eb",
                                      associate.status === "active"
                                        ? "#dc2626"
                                        : "#059669"
                                    )}
                                  >
                                    {associate.status === "active" ? (
                                      <MdAirplanemodeInactive size={13} />
                                    ) : (
                                      <MdAirplanemodeActive size={13} />
                                    )}
                                  </span>
                                  {associate.status === "active"
                                    ? "Deactivate"
                                    : "Activate"}
                                </button>
                              </li>

                              <li>
                                <a
                                  href={`${process.env.REACT_APP_API_ASSCIATELOGIN_URL}/login?mobile=${associate.mobile}&pssword=${associate.password}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center"
                                  style={{ ...dropdownItem, color: "#d97706" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#fef3e2";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#fef3e2", "#d97706")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Login as Associate
                                </a>
                              </li>

                              <li>
                                <Link
                                  to={`/team-list/${associate.mobile}?name=${encodeURIComponent(
                                    associate.username
                                  )}`}
                                  className="dropdown-item d-flex align-items-center"
                                  style={{ ...dropdownItem, color: "#7c3aed" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#f3e8ff";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#f3e8ff", "#7c3aed")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Teams
                                </Link>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleDeleteAssociate(
                                      associate.id,
                                      associate.username
                                    )
                                  }
                                  style={{ ...dropdownItem, color: "#dc2626" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#feeaeb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#feeaeb", "#dc2626")}>
                                    <RiDeleteBin5Fill size={13} />
                                  </span>
                                  Delete Associate
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="10"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No associates found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }

                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 VIEW MODAL — Beautiful Layout */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            👤 Associate Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          {selectedAssociate && (
            <Row>
              <Col md={6} className="mb-3">
                <strong style={labelColor}>Name:</strong>
                <p style={textDark}>{selectedAssociate.username || "N/A"}</p>
              </Col>
              <Col md={6} className="mb-3">
                <strong style={labelColor}>Email:</strong>
                <p style={textDark}>{selectedAssociate.email || "N/A"}</p>
              </Col>
              <Col md={6} className="mb-3">
                <strong style={labelColor}>Mobile:</strong>
                <p style={textDark}>{selectedAssociate.mobile || "N/A"}</p>
              </Col>
              <Col md={6} className="mb-3">
                <strong style={labelColor}>WhatsApp No.:</strong>
                <p style={textDark}>
                  {selectedAssociate.whatsapp_number || "N/A"}
                </p>
              </Col>
              <Col md={6} className="mb-3">
                <strong style={labelColor}>Parent ID:</strong>
                <p style={textDark}>{selectedAssociate.parent_id || "N/A"}</p>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
          <Button
            variant="secondary"
            onClick={handleCloseViewModal}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "8px 24px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL — Beautiful Layout */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Associate
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleUpdateAssociate}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editUsername">
                  <Form.Label style={labelStyle}>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    value={editFormData.username}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editEmail">
                  <Form.Label style={labelStyle}>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={editFormData.email}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editMobile">
                  <Form.Label style={labelStyle}>Mobile</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={editFormData.mobile}
                    readOnly
                    style={{ ...inputStyle, background: "#f1f5f9" }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editWhatsappNumber">
                  <Form.Label style={labelStyle}>WhatsApp Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="whatsapp_number"
                    value={editFormData.whatsapp_number}
                    maxLength="10"
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editParentId">
                  <Form.Label style={labelStyle}>Current Parent ID</Form.Label>
                  <Form.Control
                    type="tel"
                    name="parent_id"
                    value={editFormData.parent_id}
                    maxLength="10"
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loading}
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: loading
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: loading
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              {loading ? "Updating..." : "Update Associate"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
              }}
            >
              <div
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
              >
                {messageModalContent.text}
              </div>
              <div
                className="modal-footer"
                style={{
                  borderTop: "1.5px solid #e2e8f0",
                  padding: "16px 24px",
                  gap: "10px",
                }}
              >
                {messageModalContent.confirmAction ? (
                  <>
                    <button
                      type="button"
                      onClick={closeCustomMessageModal}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#1e5799",
                        color: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                      }}
                    >
                      Confirm
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={closeCustomMessageModal}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "#1e5799",
                      color: "#ffffff",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                    }}
                  >
                    OK
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const labelColor = { color: "#1e5799" };
const textDark = { margin: "4px 0", color: "#334155" };

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default ActiveAssociateList;